exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signup-modal-content[data-v-4b990074]{max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);overflow-y:auto;overscroll-behavior-y:contain;-webkit-overflow-scrolling:touch}.vm--overlay[data-v-4b990074]{background:#000;opacity:.7}.overlay-enter[data-v-4b990074],.overlay-leave-to[data-v-4b990074]{opacity:0}.overlay-enter-active[data-v-4b990074],.overlay-leave-active[data-v-4b990074]{transition:all .3s}.fade-in-enter-active[data-v-4b990074],.fade-in-leave-active[data-v-4b990074]{transition:opacity .3s}.fade-in-enter[data-v-4b990074],.fade-in-leave-to[data-v-4b990074]{opacity:0}", ""]);

// exports
